import {
  INSURANCE_TYPE_VARIANT,
  InsuranceTypeVariantVariable,
} from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { CarPriceFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductPrice/interfaces";
import { RENTAL_TYPE_VARIABLE } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseCarProduct";
import { FormikProps } from "formik";

export const getExtendedRentalCoverage = (
  formProps: FormikProps<CarPriceFormValues>,
): InsuranceTypeVariantVariable | undefined => {
  if (
    formProps.values.rentalType === RENTAL_TYPE_VARIABLE.RENTAL_TYPE_EXTENDED
  ) {
    return INSURANCE_TYPE_VARIANT.EXTENDED_RENTAL;
  }
  return undefined;
};
